import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';

import { MsalService } from '@azure/msal-angular';
import { GraphService } from 'src/app/services/graph.service';
import { PoOrderDataServiceService } from 'src/app/services/po-order-data-service.service';
import { ReportsService } from 'src/app/services/reports.service';
import { SsoSecurityService } from 'src/app/services/sso-security.service';
import { UserService } from 'src/app/services/user.service';
import { OrderDetails } from '../../model/orderdetails';
import {ReceiptDiscrepancy} from '../../model/receipt-discrepancy'
import { YesNoDynamicTitleMessageDialogComponent } from '../../yes-no-dynamic-title-message-dialog/yes-no-dynamic-title-message-dialog.component';
import { OrderdetailsComponent } from '../orderdetails/orderdetails.component';


@Component({
    selector: 'app-receipt-confirmation-discrepancy',
    templateUrl: './receipt-confirmation-discrepancy.component.html',
    styleUrls: ['./receipt-confirmation-discrepancy.component.scss'],
    standalone: false
})
export class ReceiptConfirmationDiscrepancyComponent extends OrderdetailsComponent implements OnDestroy  {
  //displayedColumns: string[] = ['productdescription', 'orderqty', 'upc', 'din','orderunit'];
  displayedColumns: string[] = ['productdescription','orderedquantity', 'orderqty', 'upc','din','orderunit'];
  sequenceNumber:number;
  reportSummaryForm: UntypedFormGroup;
  forChanged:boolean=false;
  formSave:boolean=false;
  actualquantity:number;
  dateTimeFormat:string='yyyy-MM-dd hh:mm:ss a';
  dateFormat:string='yyyy-MM-dd';
  constructor(protected route: ActivatedRoute,protected reportsService:ReportsService,protected grphservice:GraphService,protected authService: MsalService,protected userservice:UserService,protected poordersummaryservice: PoOrderDataServiceService,protected router:Router,private fb: UntypedFormBuilder,protected matdialog:MatDialog,
    protected securitysso:SsoSecurityService,protected translate:TranslateService,protected session:SessionStorageService) {
    super(route,reportsService,grphservice,authService,userservice, poordersummaryservice,router,matdialog,securitysso,translate,session);
    let lang=this.userData.language.toLowerCase();
    if(lang==='fr'){
      this.dateTimeFormat="medium";
      this.dateFormat="mediumDate"
    }
  }
  ngOnDestroy(): void {
 // this.openDialog();  
  }

  openDialog(){
 if(this.forChanged && !this.formSave){
    this.matdialog.open(YesNoDynamicTitleMessageDialogComponent, {
  
      data: {
        title: "Confirmation",
        message: "Do you want to save the changes?",
        yesButton: true,
        noButton: true,
        cancelButton: true,
        yesText: "Yes",
        noText: "No",
        cancelText: "Cancel"
      }
      ,panelClass: 'my-class'
    }).afterClosed().subscribe(res=>{
     if(res=="Yes"){
       this.updateDetails();
     }else
     if(res=="No"){
      this.backToReceiveConfirmation();
     }
    })
   }else{
    this.backToReceiveConfirmation();
   }
  }

  ngOnInit(): void {
    this.createForm();
   // this.sequenceNumber = this.route.snapshot.params['udsequenceNo'];

   this.orderdetailsresponse=this.userservice.getObject("report-rc");
   this.orderdetailsdatasource=new MatTableDataSource(this.orderdetailsresponse.orderDetailsDtoList);
   this.orderdetailsdatasource.paginator = this.paginator;
   this.orderdetailsdatasource.sort=this.sort;
 //  this.reportSummaryForm.controls.reason.disable();
   this.updateForm();
   this.onChanges()
   this.changeStaus(null);
  
  }

  onChanges(): void {
    this.forChanged=false;
    this.reportSummaryForm.controls.actualquantity.valueChanges.subscribe(val => {
    if(this.actualquantity===val){
      this.forChanged=false;
    }else{
      this.forChanged=true;
    }
    });
  }

  createForm() {

    
    this.reportSummaryForm = this.fb.group({
      actualquantity: ['', Validators.required],
      reason: ['', Validators.required],
      notes: [''],
      
      
    });

  }

  updateForm() {
    let odr:OrderDetails=this.orderdetailsresponse.orderDetailsDtoList[0];
    this.actualquantity=(odr.actualQuantityReceived !== undefined && odr.actualQuantityReceived !==null)?odr.actualQuantityReceived:odr.quantity;
    this.reportSummaryForm.controls.actualquantity.setValue(this.actualquantity);
    this.reportSummaryForm.controls.reason.setValue(odr.reason);
    this.reportSummaryForm.controls.notes.setValue(odr.notes);
    this.ocAccessEnable();
    if(this.ocRcButtonEnable){
    this.reportSummaryForm.disable();
    }else{
      this.reportSummaryForm.enable();
    }
   


  }


  ngAfterViewInit() {
  
  }


  updateDetails(){
   let valid= this.reportSummaryForm.valid;
  
   if(valid){
    this.formSave=true;
    let discrepancy=new ReceiptDiscrepancy();
    discrepancy.sequenceNumber=this.orderdetailsresponse.orderDetailsDtoList[0].sequenceNumber;
    discrepancy.actualQuantityReceived=this.reportSummaryForm.controls.actualquantity.value;
    discrepancy.reason=this.reportSummaryForm.controls.reason.value;
    let notes=this.reportSummaryForm.controls.notes.value?this.reportSummaryForm.controls.notes.value:"";
    discrepancy.notes=notes;
    this.poordersummaryservice.updatePODetails(this.orderdetailsresponse.sequenceNumber,discrepancy).subscribe(data=>{
      this.userservice.setObject('rc-unsaved-' + this.orderdetailsresponse.sequenceNumber, true);
      this.backToReceiveConfirmation();
    })
  }
  }

  backToRC(){
   this.openDialog(); 
  }
  changeStaus(event:MatSelectChange){
   let val=this.reportSummaryForm.controls.reason.value;
   const notesControl = this.reportSummaryForm.get('notes');
   if(val==='Product Not Ordered' || val ==='Order Not Received'){
    this.reportSummaryForm.controls.notes.setValidators(Validators.required);
    notesControl.updateValueAndValidity();
    // this.reportSummaryForm.controls.actualquantity.setValue(null);
    // this.reportSummaryForm.controls.actualquantity.clearValidators();
     }else
  //   if(val==='Shortage' || val ==='Overage'){

  //  // this.reportSummaryForm.controls.actualquantity.setValue(null);
  //  // this.reportSummaryForm.controls.actualquantity.clearValidators();
  //   }else
  {
    //  let odr:OrderDetails=this.orderdetailsresponse.orderDetailsDtoList[0];

   //   this.reportSummaryForm.controls.actualquantity.setValue(odr.actualQuantityReceived?odr.actualQuantityReceived:odr.quantity);
   this.reportSummaryForm.controls.notes.clearValidators();
    notesControl.updateValueAndValidity();
    }
  }
  

}
